module.exports = __webpack_public_path__ + "static/media/ar-banner.6b2bba12.png";